import axios from 'axios';
import type { CryptoCurrency } from '~/generated/prisma';

export interface CreditBalance {
  id: string;
  userId: string;
  balance: number;
  totalPurchased: number;
  totalUsed: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * Get user's credit balance
 */
export const getCreditBalanceApi = async (): Promise<CreditBalance> => {
  const response = await axios.get<{
    success: boolean;
    data: CreditBalance;
  }>('/api/credits/balance');
  return response.data.data;
};

export interface CreditStats {
  currentBalance: number;
  totalPurchased: number;
  totalSpent: number;
  monthlyUsage: number;
}

/**
 * Get user's credit statistics for stats cards
 */
export const getCreditStatsApi = async (): Promise<CreditStats> => {
  const response = await axios.get<{
    success: boolean;
    data: CreditStats;
  }>('/api/credits/stats');
  return response.data.data;
};

export interface CreditUsageOverviewData {
  date: string;
  credits: number;
  spent: number;
}

/**
 * Get user's credit usage overview for the last 6 months
 */
export const getCreditUsageOverviewApi = async (): Promise<
  CreditUsageOverviewData[]
> => {
  const response = await axios.get<{
    success: boolean;
    data: CreditUsageOverviewData[];
  }>('/api/credits/usage-overview');
  return response.data.data;
};

export interface PurchaseCreditsData {
  currency: CryptoCurrency;
  network?: string;
  amountUsd: number;
}

export interface PurchaseCreditsResponse {
  creditsPurchased: number;
  amountCrypto: number;
  amountUsd: number;
  currency: CryptoCurrency;
}

/**
 * Purchase credits using wallet balance
 */
export const purchaseCreditsApi = async (
  data: PurchaseCreditsData,
): Promise<PurchaseCreditsResponse> => {
  const response = await axios.post<{
    success: boolean;
    message: string;
    data: PurchaseCreditsResponse;
  }>('/api/credits/purchase', data);
  return response.data.data;
};
